import { Injectable } from "@angular/core";
import { WarningModalComponent } from "../../components/modals/warning-modal/warning-modal.component";
import { WarningModalData } from "../../interfaces/warning-modal-data";
import { MatDialog } from "@angular/material/dialog";

@Injectable({
  providedIn: "root",
})
export class WarningModalService {
  constructor(private modal: MatDialog) {}

  showModal(data: WarningModalData) {
    if (!data.buttonText) {
      data.buttonText = "GLOBAL.OK_BUTTON";
    }

    if (!data.icon) {
      data.icon = "warning-outline";
    }

    const dialogRef = this.modal.open(WarningModalComponent, { data });

    if (data.onClose) {
      dialogRef.afterClosed().subscribe(() => data.onClose?.());
    }
  }
}
